import React from 'react';
import { ToastProvider } from './Toast';
import { CustomCursor } from './CustomCursor';

// ============================================
// UI Provider - Combines all global UI providers
// ============================================

interface UIProviderProps {
  children: React.ReactNode;
  enableCustomCursor?: boolean;
}

export const UIProvider: React.FC<UIProviderProps> = ({
  children,
  enableCustomCursor = false, // Disabled by default as it can be intrusive
}) => {
  return (
    <ToastProvider>
      {children}
      {enableCustomCursor && <CustomCursor />}
    </ToastProvider>
  );
};

export default UIProvider;
